import { Inject } from '@angular/core';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createSubscribeActiveRouteHandler } from './../../../../utils';
import { WchLoggerService } from './../../logger/wch.logger.service';
import { ActivePageService } from './../../page/active.page.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkSubscribeActiveRouteHandler';

/**
 * Subscribes to the active route
 */
export class SdkSubscribeActiveRouteHandler implements SdkMessageHandler {

  handle: SdkMessageHandlerCallback;

  constructor(
    @Inject(ActivePageService) activePageService: ActivePageService,
    @Inject(WchLoggerService) loggerService: WchLoggerService) {
    // create the handler
    this.handle = createSubscribeActiveRouteHandler(activePageService.onRenderingContext, loggerService.get(LOGGER));
  }
}
